import React, { Component } from 'react';
import { FormGroup, Input, Badge, Container, ListGroup, ListGroupItem, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { data } from '../../constants/Constants';
import localStorageCustom from '../../utilitarios/localStorage';
import { FiltroEstadoCuenta, BuscarEstadoCuenta, PdfEstadoCuenta } from '../../store/sagas/estadoCuentaApi';
import { notificacion } from '../../utilitarios/util';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";

export class EstadoCuenta extends Component {
  static displayName = EstadoCuenta.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isEmpty: false,
      collapse1: false,
      dealer: {},
      linea: {},
      asociado: {},
      filtroAnio: [],
      selectedAnio: "",
      etPeriodo: [],
      etAnios: [],
      saludo: null,
      anioActual: new Date().getFullYear(),
      mesActual: new Date().getMonth() + 1
    };
  }
  checkParams() {
    let data = localStorageCustom.prototype.getUsuario();
    this.setState({ dealer: data.dealer, linea: data.linea, asociado: data.asociado }, () => {
      this.postFiltroEstadoCuenta(
        data.dealer.codcliente,
        data.dealer.correoElectronico,
        this.state.selectedAnio,
        data.linea.vkorg,
        data.linea.vkorg);
    });
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.checkParams();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  postFiltroEstadoCuenta = (CodigoDealer, CorreoElectronicoDealer, Gjahr, Bukrs, Vkorg) => {

    FiltroEstadoCuenta(CodigoDealer, CorreoElectronicoDealer, Gjahr, Bukrs, Vkorg)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            saludo: result.dto.filtroEstadoCuenta.saludo,
            filtroAnio: result.dto.filtroEstadoCuenta.etAnios,
            etPeriodo: result.dto.filtroEstadoCuenta.etPeriodo,
            isEmpty: (result.dto.filtroEstadoCuenta.etPeriodo.length > 0) ? false : true
          });
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Estados cuenta", error.message ?? null);
        });
      });
  }

  postBuscarEstadoCuenta = async (CodigoDealer, CorreoElectronicoDealer, item, Bukrs, Vkorg) => {
    this.setState({ loading: true });

    BuscarEstadoCuenta(CodigoDealer, CorreoElectronicoDealer, item.anio, item.id, Bukrs, Vkorg)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false });

          this.props.history.push({
            pathname: '/estado-cuenta-detalle',
            state: {
              estadoCuenta: result.dto.estadoCuenta.etResumen,
              periodo: item,
              dealer: this.state.dealer,
              linea: this.state.linea
            }
          });
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Estados cuenta", error.message ?? null);
        });
      });
  }

  render() {
    const { isEmpty, collapse1, filtroAnio, selectedAnio, etPeriodo, loading, saludo } = this.state;
    const auth = this.context;
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Hola {auth.userRazonSocial}</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link className="active" to='/dashboard'>Dashboard</Link></li>
              <li><Link to='/estado-cuenta' style={{ pointerEvents: 'none' }}>Estado de Cuenta</Link></li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile px-5">
            <a onClick={() => this.props.history.goBack()} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a>
            Hola {auth.userRazonSocial}
          </h6>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            <p className="paragraph-2 light mb-4" style={{ color: c.grisMedio }}>Queremos contarte todo lo que necesitas saber sobre tu Estado de Cuenta</p>
            <FormGroup>
              <Input type="select" style={{ maxWidth: 360, margin: 'auto' }} name="select" id="exampleSelect" value={selectedAnio}
                onChange={(itemValue, itemIndex) => this.setSelectedValue(itemValue, data.Sistema)}
              >
                <option value="">Año</option>
                {(filtroAnio.length > 0) ? filtroAnio.map((data, index) => {
                  return (
                    <option key={index + 1} value={data.value}>{data.text}</option>
                  )
                }) : null
                }
              </Input>
            </FormGroup>
            <hr />
            {isEmpty ?
              <div>
                <div className="empty">
                  <SvgAssets icon="icon-list" fill={c.celeste} />
                  <h6 className="paragraph-1 bold" style={{ color: c.celeste }}>No tienes detalle de estado de cuenta</h6>
                  <p className="paragraph-1" style={{ color: c.grisMedio }}>No cuentas con pedidos realizados, aquí encontrás tu estado de cuenta.</p>
                </div>
                <div className="text-center mt-2 mobile">
                  <Link to="/pedido-masivo" style={{ textDecoration: 'none' }}>
                    <button className='btn-block' style={{ backgroundColor: c.naranja }}>
                      ir al buscador<SvgAssets icon="icon-lupa" className='ml-2' fill="#fff" />
                    </button>
                  </Link>
                </div>
              </div>
              :
              <ListGroup flush className="list-group-desktop">
                <ListGroupItem>
                  <Row form>
                    <Col xs={2}>
                      <span className='paragraph-3 bold'></span>
                    </Col>
                    <Col xs={3}>
                      <span className='paragraph-3 bold' style={{ color: c.grisMedio }}>Mes</span>
                    </Col>
                    <Col xs={3}>
                      <span className='paragraph-3 bold' style={{ color: c.grisMedio }}>Fecha de Emisión</span>
                    </Col>
                    <Col xs={4}>
                      <span className='paragraph-3 bold'></span>
                    </Col>
                  </Row>
                </ListGroupItem>
                {/* <ListGroupItem> */}
                {etPeriodo.map((data, index) => {
                  return (
                    <ListGroupItem key={index + 1}>
                      <Row form >
                        <Col xs={2}>
                          <button className="btn-icon"
                            type="button"
                            onClick={() => this.downloadPDF(data)}>
                            <SvgAssets icon="icon-download-file" fill={c.verdeClaro} />
                          </button>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: c.grisMedio }}>{data.mes}</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: c.grisMedio }}>{data.id}/{data.anio}</span>
                        </Col>
                        <Col xs={4} className="text-right">
                          <a className="paragraph-2" style={{ cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); this.setEstadoCuentaDetalle(data) }}>Ver Detalle</a>
                          {/* <Link className='paragraph-2' to="/estado-cuenta-detalle">Ver Detalle</Link> */}
                        </Col>
                      </Row>
                    </ListGroupItem>
                  )
                })}
                {/* </ListGroupItem> */}
                {/* <ListGroupItem>
                  <Row form>
                    <Col xs={2}>
                      <button className="btn-icon">
                        <SvgAssets icon="icon-download-file" fill={c.verdeClaro} />
                      </button>
                    </Col>
                    <Col xs={3}>
                      <span className='paragraph-3 bold' style={{ color: c.grisMedio }}>Julio</span>
                    </Col>
                    <Col xs={3}>
                      <span className='paragraph-3 bold' style={{ color: c.grisMedio }}>08/2020</span>
                    </Col>
                    <Col xs={4}>
                      <Link className='paragraph-2' to="/estado-cuenta-detalle">Ver Detalle</Link>
                    </Col>
                  </Row>
                </ListGroupItem> */}
              </ListGroup>
            }
          </div>
          {isEmpty ?
            <div className="text-center mt-5 desktop">
              <Link to="/generar-pedido" style={{ textDecoration: 'none' }}>
                <button className='btn-block' style={{ backgroundColor: c.naranja }}>
                  ir al buscador<SvgAssets icon="icon-lupa" className='ml-2' fill="#fff" />
                </button>
              </Link>
            </div>
            : null
          }
        </Container>
      </div>
    );
  }
  ToggleCollapse1 = () => {
    this.setState(prevState => ({ collapse1: !prevState.collapse1 }))
  }

  setSelectedValue(e, sistema) {
    let value = e.currentTarget.value;

    this.setState({ selectedAnio: value }, () => {
      this.postFiltroEstadoCuenta(
        this.state.dealer.codcliente,
        this.state.dealer.correoElectronico,
        value,
        this.state.linea.vkorg,
        this.state.linea.vkorg);
    });
  }

  setEstadoCuentaDetalle(value, sistema) {

    this.postBuscarEstadoCuenta(
      this.state.dealer.codcliente,
      this.state.dealer.correoElectronico,
      value,
      this.state.linea.vkorg,
      this.state.linea.vkorg);
  }

  downloadPDF = (periodo) => {
    this.postPdfEstadoCuenta(
      this.state.dealer.codcliente,
      this.state.dealer.correoElectronico,
      periodo,
      this.state.linea.vkorg,
      this.state.linea.vkorg
    );
  }

  postPdfEstadoCuenta = async (CodigoDealer, CorreoElectronicoDealer, periodo, Bukrs, Vkorg) => {
    this.setState({ loading: true });

    PdfEstadoCuenta(CodigoDealer, CorreoElectronicoDealer, periodo.anio, Bukrs, Vkorg, periodo.id)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false });

          if (result.dto.urlPdf == null || result.dto.urlPdf == "") {
            notificacion("Estados cuenta Detalle", "No existe documento a descargar" ?? null);
          }
          else {
            window.open(result.dto.urlPdf, "_blank");
            // Linking.openURL(result.dto.urlPdf).catch(err => console.log("Couldn't load page", err));
          }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Estados cuenta Detalle", error.message ?? null);
        });
      });
  }
}
